import React from 'react';
import ConsentBanner from '../ConsentBanner';
import LegalLinks from '../LegalLinks';
import { familyPortalWord as w } from '../../domain/familyPortal';
import s from '../../pages/PortalPage.module.css';

// The Family Portal's one-card page (#772): its name, and what is put in it —
// the sign-in form, the closed sentence, a loading line, the family picker.
export default function PortalCard({ title = null, children }) {
  return (
    <main className={s.page}>
      <div className={s.card}>
        <h1 className={s.title}>{title || w('name')}</h1>
        {children}
        <PortalLegal />
      </div>
    </main>
  );
}

/**
 * Privacy, Terms and Cookie settings, with the cookie notice they reopen:
 * the portal is outside the app's frame, where the sign-in page carries them
 * (components/LegalLinks.jsx says why such a screen must), and analytics runs
 * here unless declined.
 */
export function PortalLegal() {
  return (
    <div className={s.legal}>
      <ConsentBanner inline />
      <LegalLinks cookieSettings />
    </div>
  );
}
